export default "__VITE_ASSET__B2N9lS7A__"